"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postResponse = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.postResponse = typebox_1.Type.Object({
    success: typebox_1.Type.Boolean(),
}, {
    description: 'Response for Post Event',
    examples: [
        {
            success: true,
        },
        {
            success: false,
        },
    ],
});
//# sourceMappingURL=post-response.js.map